import {
  UPLOADED_CATEGORY_IMG,
  UPLOADING_CATEGORY_IMG,
  UPLOADED_BRAND_IMG,
  UPLOADING_BRAND_IMG,
} from '../Constants/types'

const initialState = {
  isUploadingCategoryImage: false,
  isUploadingBrandImage: false,
}
export default function (state = initialState, action) {
  switch (action.type) {
    case UPLOADING_CATEGORY_IMG:
      return {
        ...state,
        isUploadingCategoryImage: true,
      }

    case UPLOADED_CATEGORY_IMG:
      return {
        ...state,
        isUploadingCategoryImage: false,
      }
    case UPLOADING_BRAND_IMG:
      return {
        ...state,
        isUploadingBrandImage: true,
      }
    case UPLOADED_BRAND_IMG:
      return {
        ...state,
        isUploadingBrandImage: false,
      }
    default:
      return state
  }
}
